<template>
  <z-form ref="form" class="z-card" @submit.native.prevent="submit">
    <h1 class="z-card__title">
      {{ $t('mailer.message.setting.title') }}
    </h1>

    <div class="z-card__body">
      <div class="row">
        <z-form-group class="col-12">
          <div class="mb-2">
            {{ $t('mailer.message.setting.field.webhook_sms_state.name') }}
          </div>

          <z-form-input vid="webhook_sms_state" :rules="{ url_ip: true }">
            <i-input v-model="form.webhook_sms_state" placeholder="URL" />
          </z-form-input>
        </z-form-group>
      </div>

      <div class="row mb-5">
        <z-form-group class="col-12">
          <div class="mb-2">
            {{ $t('mailer.message.setting.field.webhook_incoming_sms.description') }}
          </div>

          <z-form-input vid="webhook_incoming_sms" :rules="{ url_ip: true }">
            <i-input v-model="form.webhook_incoming_sms" placeholder="URL" />
          </z-form-input>
        </z-form-group>

        <div class="col-12">
          {{ $t('mailer.message.setting.field.webhook_incoming_sms.requirement') }}
        </div>
      </div>
    </div>
    <div class="z-card__footer">
      <i-button :loading="is_loading" type="primary" size="large" html-type="submit">
        {{ $t('shared.component.button.save') }}
      </i-button>
    </div>
  </z-form>
</template>

<script>
  import { mapActions } from 'vuex';
  import { PageServerValidationResponseMixin } from '@shared/mixins/page-server-validation-response';

  export default {
    mixins: [PageServerValidationResponseMixin],
    data: () => ({
      form: {
        webhook_sms_state: '',
        webhook_incoming_sms: ''
      },
      is_loading: false
    }),

    watch: {
      $config: {
        handler: function(val) {
          this.form.webhook_sms_state = val.webhook_sms_state || '';
          this.form.webhook_incoming_sms = val.webhook_incoming_sms || '';
        },
        immediate: true
      }
    },

    methods: {
      ...mapActions('mailer/messages', ['setBackendPostback']),

      submit: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.is_loading = true;
            this.setBackendPostback(this.form)
              .then(() => this.$noty.done())
              .catch(err => this.check_server_validation(err))
              .finally(() => (this.is_loading = false));
          }
        });
      }
    }
  };
</script>
